import { render, staticRenderFns } from "./ContentOverlay.vue?vue&type=template&id=450e5300&"
import script from "./ContentOverlay.vue?vue&type=script&lang=js&"
export * from "./ContentOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports